// extracted by css-extract-rspack-plugin
export default {"no_incident":"styles-module__no_incident--MDCoT","img":"styles-module__img--PwYdp","card":"styles-module__card--Sw1tO","container":"styles-module__container--icLSe"};